const newestFirst = (left, right) => {
    return new Date(right.submission_data).getTime() - new Date(left.submission_data).getTime()
}

export const groupApprovalsForReview = (approvals) => {
    if (!approvals) return undefined

    const approvalsByProduct = new Map()
    approvals.forEach((approval) => {
        const productId = `${approval.product}`
        const productApprovals = approvalsByProduct.get(productId) || []
        productApprovals.push(approval)
        approvalsByProduct.set(productId, productApprovals)
    })

    return Array.from(approvalsByProduct.values()).map((productApprovals) => {
        const pendingApprovals = productApprovals
            .filter((approval) => approval.status === 'pending')
            .sort(newestFirst)

        if (pendingApprovals.length > 0) {
            const [latestPending, ...olderPending] = pendingApprovals
            return {
                ...latestPending,
                staleIds: olderPending.map((approval) => approval._id),
            }
        }

        // Preserve the existing display priority for non-reviewable states, but
        // keep them out of staleIds so they can never be submitted for review.
        const displayStatus = ['processing', 'shopify_failed']
            .find((status) => productApprovals.some((approval) => approval.status === status))
        const displayCandidates = displayStatus
            ? productApprovals.filter((approval) => approval.status === displayStatus)
            : productApprovals
        const [latestApproval] = [...displayCandidates].sort(newestFirst)

        return {
            ...latestApproval,
            staleIds: [],
        }
    })
}

export const hasUnreviewedPendingApprovals = (approvals, decisions) => {
    if (!approvals) return true

    return approvals.some((approval, index) => (
        approval.status === 'pending'
        && decisions?.[index] !== true
        && decisions?.[index] !== false
    ))
}

export const filterApprovalsForStatus = (approvals, status) => {
    if (!approvals || !status) return approvals

    const normalisedStatus = `${status}`.toLowerCase()
    return approvals.filter((approval) => approval.status === normalisedStatus)
}
